import { InputText } from "primereact/inputtext";
import { InputIcon } from "primereact/inputicon";
import { IconField } from "primereact/iconfield";
import "primeicons/primeicons.css";
import styles from "./SearchField.module.scss";
import { classNames } from "primereact/utils";
import { ChangeEvent, useEffect, useState } from "react";
import { useDebounce } from "../../../infrastructure/utilities/useDebounce";

interface SearchField {
  onChange: (searchValue: string) => void;
  className?: string;
}

export const SearchField = ({ onChange, className }: SearchField) => {
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearchValue = useDebounce(searchValue, 300);

  const onSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  useEffect(() => {
    onChange(debouncedSearchValue);
  }, [debouncedSearchValue]);

  return (
    <div className={classNames(styles.root, className)}>
      <IconField iconPosition="left" className={styles.root_iconField}>
        <InputIcon className="pi pi-search"> </InputIcon>
        <InputText
          placeholder="Търсене"
          className={styles.root_iconField_field}
          onChange={onSearchChange}
        />
      </IconField>
    </div>
  );
};
